export default "__VITE_ASSET__09b5e745__"